import Image from 'next/image'
import styled, { css } from 'styled-components'

import { FlexContainer } from '@/components'

export const FlexContainerNhShape = styled(FlexContainer)<{
  isVisible: boolean
}>`
  max-width: 100vw;
  overflow: hidden;
  width: 100%;
  transition: height 0.5s ease-in-out;
  display: flex;
  flex-direction: column;
  gap: 200px;
  padding: 0 16px 200px;
  position: relative;

  @media (max-height: 750px) {
    gap: 104px;
    padding: 0 16px 104px;
  }

  ${({ isVisible }) =>
    isVisible &&
    css`
      @media (max-width: 791px) {
        gap: 24px;
        padding: 0 16px 48px;
      }
    `}
`
export const ImageWrapper = styled.div<{
  isVisible: boolean
}>`
  position: relative;
  z-index: -1;

  ${({ isVisible }) =>
    !isVisible &&
    css`
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 100vh;
    `}

  &::before {
    content: '';
    display: block;
    z-index: -1;

    position: absolute;
    right: 0px;

    width: 100%;
    height: 100%;
    max-height: 300px;

    background: ${({ theme }) => theme.gradient.primary};
    filter: blur(166px);

    @media (max-width: 700px) {
      display: none;
    }
  }
`

export const NatomContainer = styled.div`
  display: inline-block;
  position: absolute;
  opacity: 0;
  background: ${({ theme }) => theme.colors.white};
  width: 100%;
  height: 100vh;
  scale: 0;

  &.visible {
    transition: all 1s ease-in-out;
    scale: 1;
    opacity: 1;
    height: auto;
    padding-top: 112px;
    top: 200px;
  }

  &.scaleup {
    transition: all 1.4s ease-out;
  }

  @media (max-height: 750px) {
    &.visible {
      top: 120px;
    }
  }

  @media (max-width: 791px) {
    &.visible {
      top: 32px;
    }
  }
`

export type NhImageProps = {
  offset: number
}

export const NhImage = styled(Image)<NhImageProps>`
  transition: all 1s;
  will-change: transform opacity;
  transform: translate(-${(props) => props.offset}px, 0);
`
